export default {
    book: 'Rezerviraj {product}',
    age_limit: 'Samo za osobe preko {age} godina',
    change_plan: "Promjena plana",
    upgrade_product: 'Nadogradi proizvod',
    upgrade: "Nadogradnja",
    cancel_upgrade: "Otkaži nadogradnju",
    choose_product: 'Odaberi {product}',
    days: '{count} dan | {count} dana',
    login_register: "Prijava/Registracija",
    current: "Trenutno",
    keyless_benefits: {
        label: 'Ravno do automobila {0}',
        highlight: 'usluga najma™',
        list: {
            cant_lose_the_key: 'Puno osiguranje',
            zero_excess: 'Nula viška',
            phone_as_a_key: 'Telefon kao ključ',
            straight_to_car: 'Nema čekanja',
            no_queues: 'Nema redova',
            online_id_check: 'Online provjera ID-a',
            self_checkout: 'Samoplata',
        },
    },
}
